import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import EnHome from "../views/EnHome.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "扁社"
    }
  },
  {
    path: "/en",
    name: "EnHome",
    component: EnHome,
    meta: {
      title: "Pressed Press"
    }
  }
];

const router = new VueRouter({
  routes
});

export default router;
